import React from 'react';
import { AdminDashboard } from '../components/admin/AdminDashboard';

const AdminPage = () => {
  return <AdminDashboard />;
};

export default AdminPage;
